import { render, staticRenderFns } from "./CustomerRatingFilter.vue?vue&type=template&id=72e78785"
import script from "./CustomerRatingFilter.vue?vue&type=script&lang=js"
export * from "./CustomerRatingFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerRatingFilter.vue?vue&type=style&index=0&id=72e78785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports